(function () {
  var root = document.querySelector('[data-occ]');
  if (!root || window.OCCart) return;
  var cfg = JSON.parse(root.querySelector('[data-occ-config]').textContent);
  var cart = JSON.parse(root.querySelector('[data-occ-cart]').textContent);
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s) { return root.querySelector(s); };
  var itemsEl = $('[data-occ-items]'), emptyEl = $('[data-occ-empty]'), footEl = $('[data-occ-foot]'), countEl = $('[data-occ-count]');
  var totalEl = $('[data-occ-total]'), protEl = $('[data-occ-prot]'), shipEl = $('[data-occ-ship]'), shipMsg = $('[data-occ-shipmsg]'), fillEl = $('[data-occ-fill]');
  var timerEl = $('[data-occ-timer]');
  var nf;
  function money(c) {
    try { nf = nf || new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency || 'USD' }); return nf.format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isProt(it) { return cfg.protId && it.variant_id === cfg.protId; }
  function products() { return cart.items.filter(function (it) { return !isProt(it); }); }
  function protItem() { return cart.items.filter(isProt)[0]; }
  function img(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; }

  var TRASH = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';

  function render() {
    var list = products();
    var count = list.reduce(function (n, it) { return n + it.quantity; }, 0);
    countEl.textContent = count;
    itemsEl.innerHTML = list.map(function (it) {
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="occ__v">' + esc(it.variant_title) + '</p>' : '';
      return '<li class="occ__item" data-key="' + esc(it.key) + '">' +
        '<a class="occ__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" width="84" height="84" loading="lazy" decoding="async">' : '') + '</a>' +
        '<div><a class="occ__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<p class="occ__p">' + money(it.final_line_price) + was + '</p>' +
        '<div class="occ__qty"><button type="button" data-dec aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase quantity">+</button></div></div>' +
        '<button type="button" class="occ__del" data-del aria-label="Remove ' + esc(it.product_title) + '">' + TRASH + '</button></li>';
    }).join('');
    var empty = list.length === 0;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;
    shipEl.hidden = empty;
    if (protEl) protEl.checked = wantProt === null ? !!protItem() : wantProt;
    var shown = cart.total_price;
    if (wantProt && !protItem() && list.length) shown += cfg.protPrice;
    totalEl.textContent = money(shown);
    var sub = list.reduce(function (n, it) { return n + it.final_line_price; }, 0);
    var left = cfg.threshold - sub;
    var done = left <= 0;
    shipEl.classList.toggle('is-done', done);
    shipMsg.textContent = done ? 'Free shipping unlocked!' : "You're " + money(left) + ' away from free shipping';
    fillEl.style.width = (done ? 100 : Math.max(4, Math.round(sub / cfg.threshold * 100))) + '%';
    bubble(count);
  }

  function bubble(n) {
    document.querySelectorAll('cart-icon').forEach(function (ci) { if (ci.renderCartBubble) { try { ci.renderCartBubble(n, false); } catch (e) {} } });
  }

  // Serialised requests so rapid taps never race each other.
  var chain = Promise.resolve();
  function post(path, body) {
    var p = chain.then(function () {
      return fetch(base + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(path); return r.json(); });
    });
    chain = p.catch(function () {});
    return p;
  }
  var pending = 0;
  function busy(d) { pending += d; if (pending > 0) root.setAttribute('data-busy', ''); else root.removeAttribute('data-busy'); }
  function apply(next) { if (next && next.items) { cart = next; tidy(); render(); } }
  function refresh() {
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(apply).catch(function () {});
  }
  function change(key, qty) {
    busy(1);
    return post('cart/change.js', { id: key, quantity: qty }).then(apply).catch(refresh).then(function () { busy(-1); });
  }
  // Protection only makes sense with products in the cart, and only once.
  var optOut = false;
  try { optOut = sessionStorage.getItem('occ-prot-off') === '1'; } catch (e) {}
  var wantProt = cfg.auto && !optOut ? true : null;
  function tidy() {
    var p = protItem();
    if (p && !products().length) { change(p.key, 0); return; }
    if (p && p.quantity > 1) { change(p.key, 1); return; }
    syncProt();
  }
  // Protection is only written to the cart at checkout. Every cart add fires a Meta
  // "AddToCart", so adding it early would double-count every real add to cart.
  function syncProt() {
    if (wantProt === null) return;
    var p = protItem();
    if (!wantProt && p) {
      cart.total_price -= p.final_line_price;
      cart.items = cart.items.filter(function (i) { return i !== p; });
      render();
      change(p.key, 0);
    }
  }

  // Optimistic quantity updates with a short debounce per line.
  var timers = {};
  function setQty(key, qty) {
    var it = cart.items.filter(function (i) { return i.key === key; })[0];
    if (!it) return;
    qty = Math.max(0, qty);
    var unit = it.quantity ? it.final_line_price / it.quantity : it.final_price;
    var unitWas = it.quantity ? it.original_line_price / it.quantity : it.original_price;
    cart.total_price += Math.round(unit * (qty - it.quantity));
    it.final_line_price = Math.round(unit * qty);
    it.original_line_price = Math.round(unitWas * qty);
    it.quantity = qty;
    if (qty === 0) cart.items = cart.items.filter(function (i) { return i !== it; });
    render();
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { change(key, qty); }, qty === 0 ? 0 : 280);
  }

  itemsEl.addEventListener('click', function (e) {
    var li = e.target.closest('[data-key]');
    if (!li) return;
    var key = li.getAttribute('data-key');
    var it = cart.items.filter(function (i) { return i.key === key; })[0];
    if (!it) return;
    if (e.target.closest('[data-inc]')) setQty(key, it.quantity + 1);
    else if (e.target.closest('[data-dec]')) setQty(key, it.quantity - 1);
    else if (e.target.closest('[data-del]')) setQty(key, 0);
  });

  if (protEl) protEl.addEventListener('change', function () {
    wantProt = protEl.checked;
    try { if (wantProt) sessionStorage.removeItem('occ-prot-off'); else sessionStorage.setItem('occ-prot-off', '1'); } catch (e) {}
    syncProt();
    render();
  });

  // Checkout waits for any in-flight cart change so totals are always right,
  // and adds protection here (only once, only for people actually checking out).
  $('[data-occ-checkout]').addEventListener('click', function (e) {
    var needProt = wantProt && cfg.protId && !protItem() && products().length;
    if (!pending && !needProt) return;
    e.preventDefault();
    var href = this.href;
    var go = function () { window.location.href = href; };
    busy(1);
    (needProt ? post('cart/add.js', { items: [{ id: cfg.protId, quantity: 1 }] }).catch(function () {}) : chain).then(go, go);
  });

  // Reservation timer: runs only while the drawer is open.
  var tick = null;
  function deadline() {
    var key = 'occ-deadline', now = Date.now(), d = 0;
    try { d = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
    if (d <= now) { d = now + cfg.minutes * 60000; try { sessionStorage.setItem(key, String(d)); } catch (e) {} }
    return d;
  }
  function drawTimer() {
    if (!timerEl) return;
    var ms = Math.max(0, deadline() - Date.now()), s = Math.floor(ms / 1000);
    timerEl.textContent = ('0' + Math.floor(s / 60)).slice(-2) + ':' + ('0' + (s % 60)).slice(-2);
  }

  var lastFocus = null;
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    render();
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.documentElement.classList.add('occ-lock');
    if (cfg.timer && timerEl) { drawTimer(); tick = setInterval(drawTimer, 1000); }
    var x = root.querySelector('.occ__x');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('occ-lock');
    clearInterval(tick);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-occ-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  // Any link to the cart page opens the drawer instead (except on the cart page itself).
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || root.contains(a)) return;
    var path;
    try { path = new URL(a.href, location.href).pathname.replace(/\/$/, ''); } catch (err) { return; }
    if (path !== (base + 'cart').replace(/\/+/g, '/') || location.pathname.replace(/\/$/, '') === path) return;
    e.preventDefault();
    open();
    refresh();
  }, true);

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  tidy();
  render();
  window.OCCart = { open: open, close: close, refresh: refresh };
  document.dispatchEvent(new CustomEvent('occ:ready'));
})();